const portfolioData = {
  personalInfo: {
    name: "Lucio Ortigosa",
    title: "DevOps Engineer | Azure & Multi-Cloud Infrastructure",
    email: "lucio.o.dev@gmail.com",
    github: "https://github.com/lucioodev",
    // Se sirve desde public/, NO se jala de GitHub: asi el avatar de la cuenta
    // no decide la foto del sitio. Si falta, el hero cae a las iniciales.
    avatar: "/lucio-avatar.jpg",
    linkedin: "https://www.linkedin.com/in/lucio-ortigosa-alonso-190234272/",
    location: "Mexico City, Mexico (Remote)"
  },

  aboutMe:
    "DevOps Engineer with nearly 4 years of experience building cloud infrastructure, CI/CD automation and Kubernetes-based microservice deployments for enterprise platforms. Hands-on with Azure, ARM Templates, Terraform, Azure DevOps, GitLab CI, GitHub Actions, Key Vault, monitoring and production troubleshooting. Experienced in Infrastructure as Code, secrets management, log analysis and scalable cloud architectures.",

  experience: [
    {
      id: 1,
      role: "DevOps Engineer",
      company: "Zulunity",
      period: "Jan 2025 - Present",
      description:
        "Design and maintain Infrastructure as Code for enterprise microservices deployed across new cloud environments created to satisfy regional data residency requirements. Build and support CI/CD pipelines primarily in Azure DevOps, with additional work in GitLab CI and GitHub Actions, enabling repeatable deployments across multiple environments. Manage Azure resources including Key Vault, Redis, Azure AD integrations, Web Apps, databases, storage, networking and traffic management for production-grade services. Support Kubernetes-based microservice deployments, using cloud-native troubleshooting to investigate failed rollouts, pod issues, logs, secrets and certificates.",
      skills: [
        "Azure",
        "Kubernetes",
        "ARM Templates",
        "Azure DevOps",
        "GitLab CI",
        "GitHub Actions",
        "Key Vault",
        "Terraform"
      ]
    },
    {
      id: 2,
      role: "Junior DevOps Engineer",
      company: "Zulunity",
      period: "Feb 2023 - Dec 2024",
      description:
        "Implemented and maintained Azure infrastructure using Terraform and Azure DevOps pipelines for Dev, QA and UAT environments, reducing manual deployment effort and configuration drift. Automated provisioning and management of Function Apps, Web Apps, Storage Accounts, Cosmos DB, SQL Server and Key Vault while applying security practices for credential protection. Built hands-on experience with Linux, Bash, Python, cloud networking fundamentals, CI/CD and cross-team troubleshooting in Agile delivery environments.",
      skills: [
        "Terraform",
        "Azure DevOps",
        "Cosmos DB",
        "SQL Server",
        "Linux",
        "Bash",
        "Python",
        "CI/CD"
      ]
    }
  ],

  skills: [
    "Azure",
    "AWS",
    "Kubernetes",
    "Terraform",
    "Docker",
    "ARM Templates",
    "Azure DevOps",
    "GitHub Actions",
    "GitLab CI",
    "CI/CD",
    "Python",
    "Infrastructure as Code"
  ],

  education: [
    {
      id: 1,
      degree: "B.E. - Telematics Engineering",
      institution: "Universidad Abierta y a Distancia de México (UNADM)",
      period: "In progress",
      description:
        "Networking, distributed systems and telecommunications, studied alongside full-time work as a DevOps engineer."
    },
    {
      id: 2,
      degree: "Technical Degree - Computer Science / Informatics",
      institution: "Instituto Politécnico Nacional (IPN)",
      period: "Aug 2018 - Oct 2022",
      description:
        "Completed. Foundation in programming, operating systems and networks that led directly into cloud and infrastructure work."
    }
  ]
};

export default portfolioData;
